import { default as AbstractForm } from './_AbstractForm'
import { VInputText, VFormSubmission } from '../vue/components'
import { email, required } from '@vuelidate/validators'
import { API_ENDPOINTS } from '../config'

export default class extends AbstractForm {
    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el

        // Abstract vars
        this.components = {
            VInputText,
            VFormSubmission,
        }
        this.rules = {
            firstname: { required },
            lastname: { required },
            email: { email, required },
        }
        this.endpoint = API_ENDPOINTS.FORM_NEWSLETTER
        this.submission = {
            success: 'You were successfully added to our mailing list.'
        }
    }
}
